import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  ApiResourceLocation,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import {
  SOFTLINE_API_LIEFERANTENSTAMM_CONTACT_EDIT,
  SOFTLINE_API_LIEFERANTENSTAMM_KONTAKTE,
} from '../lieferantenstamm.api';
import { LieferantenQuery } from '../types/lieferanten-query';
import { SupplierContact } from '../types/supplier-contact';

@Injectable()
export class LieferantenKontakteRepository extends ReadonlyHttpApiListRepository<
  Result<SupplierContact[]>,
  LieferantenQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_LIEFERANTENSTAMM_KONTAKTE);
  }

  override getLoadPathParams(params: LieferantenQuery): Dictionary<unknown> {
    return { id: params.id };
  }

  async changeContact(
    contactKey: string,
    supplierId: number,
    patchBody: Partial<SupplierContact>
  ): Promise<SupplierContact> {
    const location = {
      path: SOFTLINE_API_LIEFERANTENSTAMM_CONTACT_EDIT,
      pathParams: {
        key: contactKey,
      },
    } as ApiResourceLocation;

    return await this.dataAccess.patch(location, {
      ...patchBody,
      supplierId,
    });
  }
}
